import React, { useState } from 'react'
import styled from '@emotion/styled';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { Modal, Col, Row } from 'antd';
import {visaIcon, masterCardIcon, discoverIcon, americanExpressIcon} from './icons';

const Container = styled.div`
    display: grid;
    grid-template-rows: 2.5rem 1fr;
    grid-gap: 20px;
`
const EditCardModal = ({editModalVisible, setEditModalVisible, stripePK}) => {

    const stripePromise = loadStripe(stripePK.stripe_pk);
   
    return(
        <Modal
            title="Edit Card Information"
            visible={editModalVisible}
            onCancel={() => setEditModalVisible(false)}
            footer={null}
        >  
        <Container>
            <Row>
                <Col span={12}>
                    <div style={{fontSize: 16, color: 'gray', marginBottom: 10}}>CREDIT CARD DETAILS</div>
                </Col>
                <Col span={12}>
                    <div style={{textAlign: 'right'}}>
                        <img style={{marginRight: 5}} src={visaIcon} height="35" />
                        <img style={{marginRight: 5}} src={masterCardIcon} width="45" />
                        <img style={{marginRight: 5}} src={discoverIcon} width="45" />
                        <img style={{marginRight: 5}}src={americanExpressIcon} width="45" />
                    </div>
                </Col>
            </Row>
            <Elements stripe={stripePromise}>
                <CheckoutForm setPaymentModalOpen={setEditModalVisible}/>
            </Elements>
        </Container>
        </Modal>
    )
}

export default EditCardModal;